"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHrefs = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var getHrefs = function (url) { return ({
    fb: "https://www.facebook.com/sharer/sharer.php?u=" + url,
    ld: "https://www.linkedin.com/shareArticle?mini=true&url=" + url,
    wa: "https://wa.me/?text=" + url,
    em: "mailto:?subject=I wanted you to see this site&amp;body=Check out this site " + url,
}); };
exports.getHrefs = getHrefs;
var shareAmp = function (props) {
    var hrefs = getHrefs(props.url);
    return (React.createElement("div", { className: "s" },
        React.createElement("a", { target: "_blank", href: hrefs.fb, className: "s__btn s__btn--fb" },
            React.createElement("span", { className: "fab fa-facebook-f" })),
        React.createElement("a", { target: "_blank", href: hrefs.ld, className: "s__btn s__btn--ld" },
            React.createElement("span", { className: "fab fa-linkedin-in" })),
        React.createElement("a", { target: "_blank", href: hrefs.wa, className: "s__btn s__btn--wa" },
            React.createElement("span", { className: "fab fa-whatsapp" })),
        React.createElement("a", { target: "_blank", href: hrefs.em, className: "s__btn s__btn--em" },
            React.createElement("span", { className: "fal fa-envelope" }))));
};
exports.default = react_redux_1.connect(function (props) { return ({
    url: props.server ? props.server.currentUrl : '',
}); }, function () { return ({}); })(shareAmp);
